import { makeListRequest } from '@/business/apiTreatment/request/makeQueryParams';
import createPlugins from '@/store/modules/requests/history/plugins';
import BaseModule from '@/store/baseModule';

export default (store) => {
  store.registerModule(
    ['properties', 'types'],
    new BaseModule({
      attributesObj: { national_symptom: { serverSide: true, values: ['N'] } },
      makeQueryParams: makeListRequest({}),
      makeHttpParamsUrl: (id) =>
        `${process.env.P2C_BASE_URI}/properties/${id}/work_order_group_types`,
    })
  );

  createPlugins({
    module: 'properties/types',
    store,
  });
};
